var _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 87.887,
    y1: 11.019,
    x2: 54.345,
    y2: 188.981
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 143.326,
    y1: 11.019,
    x2: 109.783,
    y2: 188.981
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 33.846,
    y1: 134.94,
    x2: 160.563,
    y2: 134.94
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 39.437,
    y1: 62.264,
    x2: 166.154,
    y2: 62.264
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.f4970318f32fa8f8bacf79615a26d24f.svg";
export { ForwardRef as ReactComponent };